import { render, staticRenderFns } from "./preview-notificacao-email.vue?vue&type=template&id=bd915832&scoped=true"
import script from "./preview-notificacao-email.vue?vue&type=script&lang=ts"
export * from "./preview-notificacao-email.vue?vue&type=script&lang=ts"
import style0 from "./preview-notificacao-email.vue?vue&type=style&index=0&id=bd915832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd915832",
  null
  
)

export default component.exports